import { createMarker, getSymbolPath } from '@shared/googleMaps';
import COLORS from '@shared/colorConstants';
import s from './MarkerGenerator.module.less';

const DEFAULT_STYLES = {
  largeIconScale: 15,
  smallIconScale: 11,
  strokeWeight: 2,
};

const SEARCH_REDESIGN_STYLES = {
  largeIconScale: 13,
  smallIconScale: 11,
  strokeWeight: 1,
};

class MarkerGenerator {
  constructor(shouldUseSearchRedesignStyles = false) {
    this.styles = shouldUseSearchRedesignStyles ? SEARCH_REDESIGN_STYLES : DEFAULT_STYLES;
  }

  createMarker = (map, building, isClustered, clickable) => {
    const marker = createMarker(map, this.getMarkerOptions(building), isClustered, clickable);
    marker.exclusive = building.exclusive;
    return marker;
  };

  createHoveredListingIndicator = (map, building) =>
    createMarker(map, this.getMarkerOptions(building), false);

  getLargeClusterIcon = exclusive => ({
    height: 30,
    width: 30,
    className: exclusive ? s.exclusiveMapCluster : s.mapCluster,
  });

  getSmallClusterIcon = exclusive => ({
    height: 22,
    width: 22,
    className: exclusive ? s.exclusiveMapCluster : s.mapCluster,
  });

  getMarkerIcon = (
    count,
    { highlighted, exclusive } = { highlighted: false, exclusive: false },
  ) => {
    const fillColor = exclusive ? COLORS.indigo : COLORS.indigo110;

    return {
      path: getSymbolPath().CIRCLE,
      scale: count >= 10 ? this.styles.largeIconScale : this.styles.smallIconScale,
      fillColor: highlighted ? COLORS.indigo90 : fillColor,
      fillOpacity: 1,
      strokeWeight: this.styles.strokeWeight,
      strokeColor: '#FFFFFF',
    };
  };

  getHoveredListingIndicatorIcon = building => {
    const { count } = building;
    return {
      path: getSymbolPath().CIRCLE,
      scale: count ?? 1 > 10 ? this.styles.largeIconScale : this.styles.smallIconScale,
      fillColor: COLORS.indigo90,
      fillOpacity: 1,
      strokeWeight: this.styles.strokeWeight,
      strokeColor: '#FFFFFF',
    };
  };

  getLabelOptions = text => ({
    color: '#FFFFFF',
    text,
    fontFamily: 'Roobert',
    fontSize: '12px',
  });

  getMarkerOptions = building => {
    const { longitude, latitude, count, exclusive, highlighted } = building;

    let markerOptions = {
      long: longitude,
      lat: latitude,
      icon: this.getMarkerIcon(count, { exclusive, highlighted }),
    };

    const markerLabelOptions = {
      label: this.getLabelOptions(count?.toString()),
    };

    if (count > 1) {
      markerOptions = {
        ...markerOptions,
        ...markerLabelOptions,
      };
    }

    return markerOptions;
  };

  calculateClusterStyle = markers => {
    let listingCount = 0;
    let exclusive = false;

    markers.forEach(marker => {
      if (marker.exclusive) {
        exclusive = true;
      }
      listingCount += Number(marker.label?.text || 1);
    });

    let styleIndex = 1;

    if (exclusive) {
      styleIndex = 2;
    }

    if (listingCount >= 10) {
      styleIndex = 3;

      if (exclusive) {
        styleIndex = 4;
      }
    }
    // index represents a style in the styles array above
    return { text: listingCount, index: styleIndex, exclusive };
  };
}

export default MarkerGenerator;
